export default __webpack_public_path__ + "static/media/val.294cf398.png";